$(document).ready(function () {
  $('.flipper').removeClass('flipped');

  $('.spec-btn.black').addClass('active');

  $('.spec-btn.black').click(function () {
    $('.flipper').removeClass('flipped');

    $('.spec-btn').removeClass('active');
    $(this).addClass('active');
  });

  $('.spec-btn.outline').click(function () {
    $('.flipper').addClass('flipped');

    $('.spec-btn').removeClass('active');
    $(this).addClass('active');
  });
});